export enum AuthSubRouteType {
    signIn = 'sign-in',
    signUp = 'sign-up',
    signUpFacebook = 'sign-up/facebook',
    signUpGoogle = 'sign-up/google',
    forgotPassword = 'forgot-password',
}
